import type { NotificationListParams } from "@facade/contracts";
import { notificationsApi } from "@facade/services";
import { queryOptions } from "@tanstack/react-query";

export const notificationQueryKeys = {
  all: ["notifications"] as const,
  lists: () => [...notificationQueryKeys.all, "list"] as const,
  list: (params: Omit<NotificationListParams, "cursor">) =>
    [...notificationQueryKeys.lists(), params] as const,
  unreadCount: () => [...notificationQueryKeys.all, "unread-count"] as const,
};

export const notificationQueries = {
  unreadCount: () =>
    queryOptions({
      queryKey: notificationQueryKeys.unreadCount(),
      queryFn: notificationsApi.getUnreadCount,
    }),
};
